/**
 * convertUnits
 *
 * @param {number} value
 * @param {string} from
 * @param {string} to
 * @param {Object} ENUM_UNITS
 * @returns {number}
 */
export function convertUnits(value: number, from: string, to: string): number {
  const CENTIMETER_TO_INCH = 0.393701;
  const ENUM_UNITS = {
    centimeter: {
      short: 'cm',
      long: 'centimeter',
    },
    inch: {
      short: 'in',
      long: 'inch',
    },
  };

  if (!from || !to) {
    return value;
  }

  // cm -> in
  if (
    [ENUM_UNITS.centimeter.short, ENUM_UNITS.centimeter.long].indexOf(from.toLowerCase()) > -1 &&
    [ENUM_UNITS.inch.short, ENUM_UNITS.inch.long].indexOf(to.toLowerCase()) > -1
  ) {
    return value * CENTIMETER_TO_INCH;
  }

  // in -> cm
  if (
    [ENUM_UNITS.inch.short, ENUM_UNITS.inch.long].indexOf(from.toLowerCase()) > -1 &&
    [ENUM_UNITS.centimeter.short, ENUM_UNITS.centimeter.long].indexOf(to.toLowerCase()) > -1
  ) {
    return value * (1 / CENTIMETER_TO_INCH);
  }

  return value;
}

/**
 * FilterConvertFunctions
 *
 * Library of functions to convert values from dimensions based on input parameters
 */
export const FilterConvertFunctions = {
  /**
   * convertUnitLength
   *
   * Convers dimensions based on selected unit system
   *
   * @param {string | number} value
   * @param {Record<string, any>} args
   * @param {Record<string, any>} options?
   * @returns {number}
   */
  convertUnitLength(
    value: string | number,
    args: Record<string, any>,
    options: Record<string, any> = {},
  ): number | string {
    const { reversed } = options || {};
    const from = reversed ? args.to : args.from;
    const to = reversed ? args.from : args.to;
    const parsedValue = typeof value === 'string' ? parseInt(value, 10) : value;

    if (Number.isNaN(parsedValue)) {
      return value;
    }

    return Math.round(convertUnits(parsedValue, from, to));
  },
};
